<div class="w-[80%] mx-auto">
  <div class="row">
    <div class="col-sm-5 mb-6!">
      <mat-card class="cardWithShadow p-0! h-full">
        <mat-card-content class="p-5! pb-0! h-full">
          <mat-card-title>{{'profile' | translate}}</mat-card-title>
          <div class="flex justify-center items-center text-center m-t-24">
            <img src="/assets/images/profile/user-1.jpg" class="rounded-circle mt-7" width="150" />
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-sm-7 mb-6!">
      <mat-card class="cardWithShadow py-5! px-2! mb-0!">
        <mat-card-content class="px-5! py-0!">
          <mat-card-title>{{'change password' | translate}}</mat-card-title>
          <app-change-password />
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-12">
      <mat-card class="cardWithShadow py-5! px-2! mb-0!">
        <mat-card-content class="px-5! py-0!">
          <mat-card-title>{{'personal details' | translate}}</mat-card-title>
          <app-personal-information />
        </mat-card-content>
      </mat-card>
    </div>
    @if (!isAdmin && hasCompany) {
      <app-user-license />
    }
  </div>
</div>